module.exports = __webpack_public_path__ + "static/media/beatmatch-horizontal.b2765396.svg";